<template>
  <StepTwoDialog ref="dialog" openBtnName="修改" @input="handleAcceptStep" @before-close="handleFinish"  @closed="handleDialogClose">
    <div slot="title" class="cc-title">账号名称修改</div>
    <el-form label-width="100px" class="demo-ruleForm" :model="form" :rules="rules" ref="form">
      <el-form-item  label="账号名称" prop="userName">
        <el-row>
          <el-col>
            <el-input
              v-noSpace
              placeholder="请输入新账号名称"
              v-model.trim="form.userName"
              />
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </StepTwoDialog>
</template>

<script>
import StepTwoDialog from './StepTwoDialog'
export default {
  components: {
    StepTwoDialog
  },
  data() {
    return {
      activeStep: 0,
      form: {
        userName: undefined
      },
      rules: {
        userName: [
          { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' }
        ]
      }

    }
  },
  computed: {

  },
  methods: {
    handleAcceptStep(val) {
      this.activeStep = val
    },
    handleFinish() {
      if (this.form.userName) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$service.updateUsername({ username: this.form.userName }, '修改成功')
              .then(() => {
                this.$service.getUserInfo()
                this.$refs.form.resetFields()
                this.$refs.dialog.isVisableDialog = false
              })
          }
        })
      } else {
        this.$refs.form.resetFields()
        this.$refs.dialog.isVisableDialog = false
      }
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
      this.$refs.dialog.isVisableDialog = false
    }
  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
.cc-title
  text-align center
  color #ff8b00
  font-size 18px
  font-weight bold
  padding-bottom 15px
>>>.el-dialog__body
  padding 0
.demo-ruleForm
  max-width 500px
.demo-ruleForm >>>.el-form-item
  margin-bottom 15px
</style>
